<template>
  <div class="select-all-wrap">
    <ul v-if="classList.length" class="class1-list">
      <li
        v-for="(item, index) in classList"
        :key="index"
        :class="classIndex === index ? 'active' : ''"
        @click.prevent.stop="selectClassList(item, index)"
      >
        {{ item.name }}
      </li>
    </ul>
    <ul v-if="class2List.length" class="class2-list">
      <li
        v-for="(item, index) in class2List"
        :key="index"
        :class="class2Index === index ? 'active' : ''"
        @click.prevent.stop="selectClass2List(item, index)"
      >
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {}
  },
  computed: {
    ...mapState('activityGoods', {
      classList: state => state.classList,
      class2List: state => state.class2List,
      classIndex: state => state.classIndex,
      class2Index: state => state.class2Index,
      queryData: state => state.queryData,
      sale_c1_id: state => state.sale_c1_id
    })
  },
  methods: {
    ...mapActions('activityGoods', [
      'class1ListClick',
      'class2ListClick',
      'setActQueryData',
      'clearSkuList',
      'clearQueryData',
      'setFilterSort',
      'setKeyWord',
      'setSallClass1Id',
      'clearClass2Index'
    ]),
    selectClassList(item, index) {
      this.setSallClass1Id(Number(item.id))
      this.clearClass2Index()
      this.setFilterSort(false)
      this.class1ListClick({ item, index })
      this.setQueryData('page', 0)
      if (Number(item.id) === 0) {
        this.clearQueryData()
        this.setQueryData('saleC1Id', item.id)
        this.setQueryData('page', 0)
        this.$emit('closeMask')
        this.clearSkuList()
        this.setKeyWord('')
        this.$emit('update:allSort', false)
        this.$emit('update:allDefalut', true)
        this.$emit('update:allUp', false)
        this.$emit('update:allDown', true)
        this.$emit('update:priceSort', false)
        this.$emit('update:increment', true)
        this.$emit('update:decrement', true)
        this.$emit('update:allUp', false)
        this.$emit('activitySkuListOptimize')
      }
    },
    selectClass2List(item, index) {
      this.clearQueryData()
      if (this.sale_c1_id !== 0) {
        this.setQueryData('saleC1Id', this.sale_c1_id)
      }
      this.setKeyWord('')
      this.setFilterSort(false)
      this.$emit('update:allDefalut', false)
      this.$emit('update:priceSort', false)
      this.$emit('update:decrement', true)
      this.$emit('update:increment', true)
      this.$emit('update:allSort', true)
      this.$emit('update:allUp', false)
      this.$emit('update:allDown', true)
      this.class2ListClick({ item, index })
      this.setQueryData('saleC2Id', item.id)
      this.setQueryData('page', 0)
      this.clearSkuList()
      this.$emit('activitySkuListOptimize')
      this.$emit('closeMask')
    },
    setQueryData(name, data) {
      const queryObj = {}
      queryObj[name] = data
      this.setActQueryData(queryObj)
    }
  }
}
</script>

<style lang="scss" scoped>
.select-all-wrap {
  display: flex;

  width: 100%;
  height: 6.68rem;

  background: #fff;
  .class1-list,
  .class2-list {
    height: 100%;

    background: #fff;

    flex: 1;

    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    -webkit-text-size-adjust: none;

    li {
      display: flex;

      height: 0.96rem;
      padding: 0 0.56rem;
      box-sizing: border-box;

      flex-direction: column;
      justify-content: center;

      font-size: 0.26rem;
      color: #666666;
    }
    li.active {
      font-weight: 500;
      color: #0daf52;
    }
  }
  .class1-list {
    background: #fafafa;

    flex: none;

    text-align: center;
    li {
      width: 2.16rem;
      padding: 0;
    }
    li.active {
      background: #fff;

      color: #333;
    }
  }
  .class2-list {
    flex: auto;
    li {
      padding-left: 0.7rem;
    }
  }
}
</style>
